export * from './MegaphoneIcon';
export * from './MegaphoneIcon16Light';
export * from './MegaphoneIcon16Regular';
export * from './MegaphoneIcon16Solid';
export * from './MegaphoneIcon20Light';
export * from './MegaphoneIcon20Regular';
export * from './MegaphoneIcon20Solid';
export * from './MegaphoneIcon24Regular';
export * from './MegaphoneIcon24Solid';
export * from './MegaphoneIcon32Regular';
export * from './MegaphoneIcon64Regular';
